var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',_vm._g(_vm._b({staticClass:"l-card",attrs:{"ripple":false}},'v-card',_vm.$attrs,false),_vm.$listeners),[_vm._t("title"),_vm._v(" "),(_vm.scrollable)?_c('v-container',{staticClass:"content pa-0"},[_vm._t("content")],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }